import {types} from './actions.js';

const initialState = {
  articles: [],
  categories: [],
  tags: [],
  currentArticle: null,
  loadingArticle: false,
  loadingArticles: false,
  loadingCategories: false,
  loadingTags: false,
  loader: true,
  endLoading: false,
  prevArticle: null,
  nextArticle: null
};

export default function reducer(state = initialState, action) {
  if (action.type === types.SET_CURRENT_ARTICLE) {
    return {
      ...state,
      currentArticle: action.article
    };
  } else if (action.type === types.SET_CATEGORIES) {
    return {
      ...state,
      categories: action.categories
    };
  } else if (action.type === types.SET_TAGS) {
    return {
      ...state,
      tags: action.tags
    };
  } else if (action.type === types.SET_ARTICLES) {
    return {
      ...state,
      articles: action.articles
    };
  } else if (action.type === types.REMOVE_ARTICLES) {
    return {
      ...state,
      articles: [],
    };
  } else if (action.type === types.SET_PREV_ARTICLE) {
    return {
      ...state,
      prevArticle: action.prevArticle,
    };
  } else if (action.type === types.SET_NEXT_ARTICLE) {
    return {
      ...state,
      nextArticle: action.nextArticle
    };
  } else if (action.type === types.START_LOADING_ARTICLE) {
    return {
      ...state,
      loadingArticle: true
    };
  } else if (action.type === types.STOP_LOADING_ARTICLE) {
    return {
      ...state,
      loadingArticle: false,
      endLoading: true,
    };
  }  else if (action.type === types.START_LOADING_ARTICLES) {
    return {
      ...state,
      loadingArticles: true
    };
  } else if (action.type === types.STOP_LOADING_ARTICLES) {
    return {
      ...state,
      loadingArticles: false,
      endLoading: true,
    };
  }   else if (action.type === types.START_LOADING_CATEGORIES) {
    return {
      ...state,
      loadingCategories: true
    };
  } else if (action.type === types.STOP_LOADING_CATEGORIES) {
    return {
      ...state,
      loadingCategories: false,
      endLoading: true,
    };
  }   else if (action.type === types.START_LOADING_TAGS) {
    return {
      ...state,
      loadingTags: true
    };
  } else if (action.type === types.STOP_LOADING_TAGS) {
    return {
      ...state,
      loadingTags: false,
      endLoading: true,
    };
  } else if(action.type === types.CANCEL_LOADER) {
    return {
      ...state,
      loader: false,
    }
  }
  return state;
}